import React, { useEffect } from "react";
import { connect } from "react-redux";
import UserAvatar from "assets/img/avatars/user.png";
import { 
	getTopFarmers
} from "../../../../redux/dashboard/dashboardState";
import { Table } from 'antd';
import {displayFullName} from '../../../../utils/index';
import AnimalCount from "./AnimalCount";

function TopFarmersList({getTableData, filters, recordList, requesting, success, error, ...props}) {

  useEffect(() => {
    getTableData(filters);
    }, [getTableData, filters]);


  const columns = [
		{
        title: `Name`,
        dataIndex: 'user_id',
        key: 'user_id',
        width: '35%',
        render:(user_id,record) => 
        <div className="flex items-center gap-2">   
          <img
            className="h-10 w-10 rounded-full"
            src={UserAvatar}
            alt="User Avatar"
          />                      
          <p className="text-sm font-medium text-theme-700 dark:text-white">
            {displayFullName(record)}
          </p>
        </div>
    },
    {
        title: `Active Animals`,
        dataIndex: 'record',
        key: 'record',
        width: '54%',
        render:(carabao, record) => 
          <div className="flex flex-wrap gap-2">
            <AnimalCount title="Carabao" count={record?.carabao}/>
            <AnimalCount title="Cattle" count={record?.cattle}/>
            <AnimalCount title="Goat" count={record?.goat}/>
            <AnimalCount title="Sheep" count={record?.sheep}/>
            <AnimalCount title="Swine" count={record?.swine}/>
            <AnimalCount title="Chicken" count={record?.chicken}/>
            <AnimalCount title="Duck" count={record?.duck}/>
          </div>
    },
    {
        title: <div className="w-full text-right">Total</div>,
        dataIndex: 'total',
        key: 'total',
        width: '8%',
        render:(total) => <div className="w-full text-right">{total ?? 0}</div>
    },
    {
        title: <div className="w-full text-right">Points</div>,
        dataIndex: 'points',
        key: 'points',
        width: '8%',
        render:(points) => <div className="w-full text-right">{points ?? 0}</div>
    },
  ];

  return (
      <div className="pt-4 w-full overflow-x-scroll px-4 md:overflow-x-hidden overflow-y-auto">
        <h2 className="font-medium text-xl mb-4">Overall</h2>
        <Table
          dataSource={recordList}
          columns={columns} 
          rowKey={(record) => record.id}
          pagination={false}
        />

      </div>
  );
}

const mapStateToProps = (state) => ({
  filters: state.dashboard.topFarmersFiters,
  requesting: state.dashboard.topFarmers?.requesting,
  success: state.dashboard.topFarmers?.success,
  error: state.dashboard.topFarmers?.error,
  recordList: state.dashboard.topFarmers?.items,
});

const mapDispatchToProps = (dispatch) => ({
  getTableData: (data) => dispatch(getTopFarmers(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopFarmersList);
